// Features/TeeInBlue-Image-Reloader/Validate.ts
async function validateURL(path) {
  try {
    const url = new URL(path);
    const now = Date.now();
    const { pathname, origin } = url;
    const uri = `${origin}${pathname}?${now}`;
    const response = await fetch(uri);
    if (response.ok)
      return uri;
  } catch (exception) {
    error(exception);
  }
  return null;
}
var { error } = console;

// Features/TeeInBlue-Image-Reloader/Component.ts
var Selector_Loading = `.TIB-Image-Loading`;
var Selector_Error = `.TIB-Image-Error`;
var Selector_Image = `.TIB-Image`;

class Component extends HTMLElement {
  parts;
  constructor() {
    super();
    this.parts = {
      loading: this.querySelector(Selector_Loading),
      error: this.querySelector(Selector_Error),
      image: this.querySelector(Selector_Image)
    };
    this.loadImage();
  }
  set status(status) {
    this.dataset.status = status;
  }
  async getValidated() {
    const { src } = this.parts.image;
    return await validateURL(src);
  }
  async loadImage() {
    const { image } = this.parts;
    this.status = "Loading";
    let tries = 0;
    const interval = setInterval(async () => {
      tries++;
      if (tries > 0) {
        const uri = await this.getValidated();
        if (uri) {
          clearInterval(interval);
          image.src = uri;
          const delay = tries === 1 ? 1500 : 0;
          setTimeout(() => {
            this.status = "Success";
          }, delay);
        }
      } else {
        clearInterval(interval);
        this.status = "Error";
      }
    }, 2000);
  }
}

// Features/TeeInBlue-Image-Reloader/mod.ts
customElements.define("reloaded-tib-image", Component);
